import * as React from 'react';
import ReactOnRails from 'react-on-rails';

import GenLoadingSpinner from 'Gen/LoadingSpinner/component';

export default class GenPostButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this.formRef = React.createRef();
  }

  static defaultProps = {
    highlighted: false,
    disabled: false,
    loading: false,
    data: {},
  };

  handleSubmit = (event) => {
    // Prevent default form submission behavior
    event.preventDefault();
    event.stopPropagation();



    // Set loading state to true
    this.setState({ isLoading: true });

    // Get the form element using the ref
    const form = this.formRef.current;

    if (!form) {
      console.error('Form reference not found');
      this.setState({ isLoading: false });
      return false;
    }

    // If downloadFile is true, use a different approach
    if (this.props.downloadFile) {

      try {
        // Create a clone of the form
        const formClone = form.cloneNode(true);

        // Make sure the form has the correct attributes
        formClone.setAttribute('method', 'POST');
        formClone.setAttribute('action', this.props.url);
        formClone.setAttribute('target', '_blank'); // Always open in new tab for downloads

        // Add to document, submit, then remove
        document.body.appendChild(formClone);
        formClone.submit();

        // Reset loading state after a short delay
        setTimeout(() => {
          this.setState({ isLoading: false });
          document.body.removeChild(formClone);
        }, 1000);
      } catch (error) {
        console.error("GenPostButton: Error during file download submission:", error);
        this.setState({ isLoading: false });
      }

      return false;
    }

    // Firefox-compatible form submission using fetch API

    const formData = new FormData(form);
    const csrfToken = ReactOnRails.authenticityToken();

    // Add CSRF token to form data if not already present
    if (csrfToken && !formData.has('authenticity_token')) {
      formData.append('authenticity_token', csrfToken);
    }

    // Convert FormData to URLSearchParams for application/x-www-form-urlencoded
    const params = new URLSearchParams();
    for (let [key, value] of formData.entries()) {
      params.append(key, value);
    }

    // Use fetch API for more reliable cross-browser submission
    fetch(this.props.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': csrfToken || '',
        'Accept': 'text/html,application/xhtml+xml,application/xml'
      },
      body: params,
      credentials: 'same-origin',
      redirect: 'follow'
    })
      .then(response => {
        if (response.redirected) {
          window.customAlertBox({
            title: "Pushed to OM!",
            message: "Ongoing Maintenance Version updated.",
          });
          window.location.href = response.url;
        } else if (response.ok) {
          window.location.reload();
        } else {
          console.error('Form submission failed with status:', response.status);
          this.setState({ isLoading: false });
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
        this.setState({ isLoading: false });

        // Last resort fallback - try traditional form submission
        try {
          // Clone the form to avoid issues with event handlers
          const clonedForm = form.cloneNode(true);
          clonedForm.setAttribute('target', this.props.openInNewTab ? '_blank' : '_self');
          document.body.appendChild(clonedForm);
          clonedForm.submit();
          document.body.removeChild(clonedForm);
        } catch (submitError) {
          console.error('Traditional form submission also failed:', submitError);
          this.setState({ isLoading: false });
        }
      });

    return false;
  };

  render() {
    let classes = "gen-button";

    if (this.props.disabled) {
      classes += " disabled";
    }

    if (this.props.highlighted) {
      classes += " highlighted";
    }

    if (this.props.small) {
      classes += " small";
    }

    if (this.props.className) {
      classes += " ";
      classes += this.props.className;
    }

    const authToken = ReactOnRails.authenticityToken();

    if (this.state.isLoading || this.props.loading) {
      return (
        <div className={classes}>
          <span className="is-loading"><GenLoadingSpinner variant='small'/></span>
        </div>
      );
    } else {
      return (
        <div className={classes} onClick={(e) => e.stopPropagation()}>
          <form
            ref={this.formRef}
            action={this.props.url}
            method="POST"
            target={this.props.openInNewTab ? "_blank" : "_self"}
            onSubmit={this.handleSubmit}
            data-remote="false"
            data-no-turbolink="true"
          >
            {Object.keys(this.props.data).map((key) => {
              return (
                <input
                  type="hidden"
                  key={key}
                  name={key}
                  value={JSON.stringify(this.props.data[key])}
                />
              );
            })}
            <input
              key="submit"
              type="submit"
              value={this.props.name}
              disabled={this.props.disabled}
              data-confirm={this.props.confirmMessage}
              onClick={(e) => e.stopPropagation()}
            />
            <input
              type="hidden"
              name="authenticity_token"
              value={authToken || ""}
            />
          </form>
        </div>
      );
    }
  }
}